import { base } from '@modules';

import { EnterpriseSchema } from './Enterprise.schema';

export const initialState: EnterpriseSchema = {
  list: { ...base.state, data: [] },
  entity: { ...base.state, data: undefined },
};
